export default "__VITE_ASSET__BQoZw$BS__"